import { Button, Col, Form, Input, Row } from 'antd'
import { get, set, size } from 'lodash'
import { defaultFormItemLayout, rules } from '../modules/FormItems'
import React, { useState } from 'react'

function RegisteredEmails (props) {
  const { getFieldDecorator, getFieldValue, doc } = props

  const [registeredEmailsArraySize, setRegisteredEmailsArraySize] = useState(size(get(doc, 'registeredEmails')) || 1)

  return (
    <Row>
      {Array(registeredEmailsArraySize)
        .fill()
        .map((_, i) => (
          <Col span={12}>
            <Form.Item label={`Registered Email [${i + 1}]`} {...defaultFormItemLayout}>
              {getFieldDecorator(`registeredEmails[${i}]`, {
                initialValue: get(doc, `registeredEmails[${i}]`),
                rules: rules.input,
              })(<Input placeholder={`Registered Email [${i + 1}]`} style={{ width: '80%' }}/>)}
              <Button
                style={{ marginLeft: 5 }}
                type="danger"
                size="small"
                onClick={() => {
                  let emails = getFieldValue(`registeredEmails`)
                  console.log({ emails })
                  emails.splice(i, 1)
                  console.log({ emails })
                  set(doc, `registeredEmails`, emails)
                  setRegisteredEmailsArraySize(registeredEmailsArraySize - 1)
                }}>
                Remove
              </Button>
            </Form.Item>
          </Col>
        ))}
      <Col span={12}>
        <Button
          type={'primary'}
          size="small"
          style={{ marginLeft: 10 }}
          icon={'plus'}
          onClick={() => setRegisteredEmailsArraySize(registeredEmailsArraySize + 1)}>
          Add New Email
        </Button>
      </Col>
    </Row>
  )
}

export default RegisteredEmails
